/**
 * This looks silly right now but it allows for us to make modifications in the future
 * (or switch to a different library) without impacting consumers. As long as we
 * keep the same interface that axios provides by default, we can be backwards-compatible.
 *
 * Don't use import/export so this can run in node native
 */
const HmacSHA256 = require('crypto-js/hmac-sha256');
const EncBase64 = require('crypto-js/enc-base64');
const axios = require('axios');

const generateHMACKey = (payload, hmacKey) => {
  const signature = JSON.stringify(payload);
  const signatureBytes = HmacSHA256(signature, hmacKey);
  const hmacValue = EncBase64.stringify(signatureBytes);
  return `MAC ${ hmacValue}`;
};

// adding HMAC value to http headers for post and put

const newHttpHeaders = (data, config) => {
  let configObj = null;
  if (data && config && config.HMACKey) {
    const hmacVal = generateHMACKey(data, config.HMACKey);
    configObj = {
      ...config,
      headers: {
        ...config.headers,
        HMAC: hmacVal,
      },
    };
  } else {
    configObj = config;
  }
  return configObj;
};

const http = {

  post: (url, data, config) => {
    let newConfig = null;
    newConfig = newHttpHeaders(data, config);
    return axios.post(url, data, {
      ...newConfig,
    });
  },

  put: (url, data, config) => {
    let newConfig = null;
    newConfig = newHttpHeaders(data, config);
    return axios.put(url, data, {
      ...newConfig,
    });
  },

  delete: (url, config) => {
    let newConfig = null;
    newConfig = newHttpHeaders(config?.data, config);
    return axios.delete(url, {
      ...newConfig,
    });
  },
};
const newAxios = { ...axios, ...http };
module.exports = newAxios;
